import Glide, { Breakpoints } from "@glidejs/glide";

document.addEventListener("DOMContentLoaded", () => {

  if (document.querySelector(".glide-languages")) {
    const glideLanguages = new Glide(".glide-languages", {
      type: "carousel",
      animationDuration: 800,
      gap: 40,
      perView: 4,
      rewind: false,
      breakpoints: {
        600: {
          perView: 1,
        },
        800: {
          perView: 2,
        },
        1000: {
          perView: 3,
        },
      }
    });

    const autoArrows = function (Glide, Components, Events) {
      const AutoArrows = {
        NAV_SELECTOR: '[data-arrows]',
        mount() {
          const arrowsWrapper =
                Components.Html.root.querySelector(this.NAV_SELECTOR);

          const [arrowLeft, arrowRight] = arrowsWrapper.querySelectorAll('button');

          arrowLeft.onclick = () => {
            Components.AutoBullets.navigateTo(Glide.index - 1);
          };

          arrowRight.onclick = () => {
            Components.AutoBullets.navigateTo(Glide.index + 1);
          }
        },
      };
      return AutoArrows;
    }

    const autoBullets = function (Glide, Components, Events) {
      const AutoBullets = {
        NAV_SELECTOR: '[data-glide-el="controls[nav]"]',
        mount() {
            this._nodes = [];

            // Automatically create bullets
            const { perView } = Glide.settings;
            const totalPages = Math.ceil(Components.Html.slides.length / perView);
            this._prevPerView = perView;
            const bulletWrapper =
                Components.Html.root.querySelector(this.NAV_SELECTOR);

            if (bulletWrapper) {
                const fragment = document.createDocumentFragment();
                for (let index = 0; index < totalPages; index++) {
                    let button = document.createElement('button');
                    button.className = 'glide__bullet';
                    button.setAttribute('data-index', index);
                    button.setAttribute('data-glide-dir', '=' + index * perView);
                    button.onclick = () => {
                      const selIndex = button.getAttribute('data-index');
                      Glide.index = selIndex;
                    }
                    this._nodes.push(button);
                    fragment.appendChild(button);
                }
                bulletWrapper.innerHTML = '';
                bulletWrapper.appendChild(fragment);
            }

            Components.Controls.addBindings();
        },
        navigateTo(index) {
          const { perView } = Glide.settings;

          if (index > this._nodes.length - 1) {
            glideLanguages.go(`=0`);
            Glide.index = 0;
          } else if (index < 0) {
            glideLanguages.go(`=${(this._nodes.length - 1) * perView}`);
            Glide.index = this._nodes.length - 1;
          } else {
            glideLanguages.go(`=${index * perView}`);
            Glide.index = index;
          }
        },

        reset() {
          const { perView } = Glide.settings;
          if (perView !== this._prevPerView) {
            // reset carousel to initial position when the number of slides changes
            glideLanguages.go('<<');
            Glide.index = 0;
            this.mount();
          }
        }
      };
      Events.on(['resize'], () => {
        AutoBullets.reset();
      });
      return AutoBullets;
    };
    glideLanguages.mount({
      AutoArrows: autoArrows,
      AutoBullets: autoBullets
    });
  }
});
